import React, { Component } from 'react';
import { Container, Row, Col} from 'react-bootstrap';
import { MapContainer, Marker, TileLayer, Tooltip } from 'react-leaflet';
import { strings } from '../../resources/strings';
import { ticketOfficePageIcon } from '../leaflet/StopIcons';

export class TicketOffice extends Component {
    renderTerminal(info) {
        return (
            <div className="terminal-box" key={info.id}>
                <div className="terminal-info">
                    <b>{info.name}<br />
                        {info.address}<br />
                        {info.postal}</b><br />
                    <b>{strings.email}:</b> geral@transportesalentejolitoral.pt<br />
                    <b>{strings.phone}:</b> {info.phone}<br /><br />
                    <p>{strings.contactWorkingDays}<br />
                        {strings.contactSaturdays}<br />
                        {strings.contactSundays}</p>
                </div>

                <MapContainer className="map" center={info.coords} zoom={16} scrollWheelZoom={true}>
                    <TileLayer
                        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/attributions">CARTO</a>'
                        url="https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png"
                    />
                    <Marker position={info.coords} icon={ticketOfficePageIcon}>
                        <Tooltip><strong>{info.tooltip}</strong></Tooltip>
                    </Marker>
                </MapContainer>
            </div>
        );
    }

    render() {
        const terminals = [
            {
                id: 'evora',
                name: 'Terminal Rodoviário de Évora',
                address: 'Av.Tulio Espanca - Terminal Rodoviário',
                postal: '7005 - 840 Évora',
                phone: '269 034 827',
                coords: [38.5679406, -7.9181205],
                tooltip: 'Terminal Rodoviário de Évora'
            },
            {
                id: 'santiago',
                name: 'Terminal Rodoviário de Santiago do Cacém',
                address: 'Rua Cidade de Setúbal nº14',
                postal: '7540 - 150 Santiago do Cacém',
                phone: '269 827 148',
                coords: [38.0187255, -8.6932002],
                tooltip: 'Santiago do Cacém'
            },
            {
                id: 'alcacer',
                name: 'Terminal Rodoviário de Alcácer do Sal',
                address: 'Avenida José Saramago - Terminal Rodoviário',
                postal: '7580 - 201 Alcácer do Sal',
                phone: '265 622 451',
                coords: [38.375820, -8.510323],
                tooltip: 'Alcácer do Sal'
            },
            {
                id: 'odemira',
                name: 'Terminal Rodoviário de Odemira',
                address: 'Estrada da Circunvalação 1D',
                postal: '7630-130 Odemira',
                phone: '269 034 827',
                coords: [37.5987724, -8.6446127],
                tooltip: 'Odemira'
            }
        ];

        return (
            <Container fluid className="ticket-office-container">
                <Row className="terminal-row">
                    {terminals.map(info => (
                        <Col key={info.id} xs={12} sm={6} md={4}>
                            {this.renderTerminal(info)}
                        </Col>
                    ))}
                </Row>
            </Container>
        );
    }
}
